import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useConductor } from "@/utils/conductor";
import { IconsName } from "@/utils/icons";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import ButtonIcon from "../molecules/ButtonIcon.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useI18n();

const { isPlaying, start, stop } = useConductor();
const loading = ref(false);
const icon = computed<keyof typeof IconsName>(() => {
  if (loading.value) {
    return "spinner";
  }
  return isPlaying?.value ? "volume" : "volumeOff";
});
const toggleAudio = async () => {
  if (isPlaying?.value) {
    stop();
  } else {
    loading.value = true;
    await start();
    loading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ButtonIcon, {
    class: _normalizeClass(["text-white", { 'animate-spin': loading.value }]),
    name: _unref(icon),
    disabled: loading.value,
    "aria-label": _unref(t)(`options.sound.${_unref(isPlaying) ? 'mute' : 'unmute'}`),
    size: "s",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleAudio()))
  }, null, 8, ["name", "disabled", "aria-label", "class"]))
}
}

})